import React from "react";

export function Tab({ active, onClick, icon: Icon, label, testid }) {
  return (
    <button
      onClick={onClick}
      data-testid={testid}
      className={`flex-1 min-w-[150px] px-4 py-3 flex items-center justify-center gap-2 text-xs uppercase tracking-[0.15em] font-bold transition-colors ${
        active ? "bg-primary-brand text-white" : "bg-white text-slate-700 hover:text-slate-900"
      }`}
    >
      <Icon className="h-4 w-4" /> {label}
    </button>
  );
}

export function EmptyState({ label }) {
  return <div className="border border-slate-200 bg-white p-16 text-center text-slate-500 text-sm">{label}</div>;
}

export const portalInputCls = "w-full bg-transparent border border-slate-200 focus:border-primary-brand outline-none px-4 py-3 text-sm text-slate-900";
